import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditFilled,
  MoreOutlined,
  SaveFilled,
} from "@ant-design/icons";
import {
  Box,
  Card,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useNotification } from "../../../hooks/useNotification.js";
import { JournalAPIService } from "../../../services/api/JournalAPIService";
import {
  API_ERROR_MESSAGE,
  API_SUCCESS_MESSAGE,
  DATE,
} from "../../../shared/constants";
import ConfirmationDialog from "../../common/ConfirmationDialog.js";
import magicToolIcon from "../../../assests/Images/magicTool.png";
import ActionMenu from "../../../pages/Extra/ActionMenu.js";
import html2canvas from "html2canvas";
import { toPng } from "html-to-image";
import DownloadBackdrop from "../../../pages/Memory_journal/DownloadBackdrop.js";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { isRealSafari } from "../../../shared/utils.js";

const ffmpeg = new FFmpeg();


const ImageCardTemplateEdit = ({
  journalId,
  author,
  imgSrc,
  text,
  date,
  borderColor = "#f72bb1",
  backgroundColor = "#007bff",
  imageBottomRight,
  imageBottomRightStyle,
  textColor,
  disableEye = false,
  editData = false,
  open,
  onClose,
  pageRefreshCallback,
  handleOpenEditor,
}) => {
  const [showEye, setShowEye] = useState(false);
  const { notifyError, notifySuccess } = useNotification();
  const [editMode, setEditOpen] = useState(editData);
  const [editableDate, setEditableDate] = useState(dayjs(date));
  const [editableText, setEditableText] = useState(text);
  const [anchorEl, setAnchorEl] = useState(null);
  const textRef = useRef(null);
  const [isSingleLine, setIsSingleLine] = useState(true);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const cardRef = useRef(null);
  const [downloading, setDownloading] = useState(false);
  const openMenu = Boolean(anchorEl);

  const handleMenuClick = (action) => {
    switch (action) {
      case "edit":
        handleEdit();
        break;
      case "delete":
        handleDelete();
        break;
      case "effect":
        handleOpenEditor(imgSrc, journalId);
        break;
      case "save":
        handleDownloadImage();
        break;
      case "drag":

        console.log("Drag action triggered");
        // Optional: set some dragging state here
        break;
      default:
        break;
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setShowEye(false);
  };

  const handleCloseDialog = () => {
    onClose();
    setEditOpen(false);
    setShowEye(false);
  };

  const handleEdit = () => {
    setShowEye(false);
    setEditOpen(true);
  };

  const handleCancelDelete = () => {
    setConfirmDialogOpen(false);
  };

  const handleDelete = () => {
    setConfirmDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    setConfirmDialogOpen(false);

    JournalAPIService.journalDelete(journalId)
      .then((response) => {
        notifySuccess(
          response.message || API_SUCCESS_MESSAGE.DELETED_SUCCESSFULLY
        );
        pageRefreshCallback();
      })
      .catch((errResponse) => {
        notifyError(
          errResponse?.response?.data?.message ||
            API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
        );
      });
    handleCloseDialog();
  };

  const preloadImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous"; // Important if using CORS images
      img.onload = resolve;
      img.onerror = reject;
      img.src = url;
    });
  };

  const waitForImages = (container) => {
    const images = container.querySelectorAll("img");
    const promises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) return resolve();
          img.onload = img.onerror = resolve;
        })
    );
    return Promise.all(promises);
  };

  const wait = (ms) => new Promise((res) => setTimeout(res, ms));


  const handleDownloadImage = async () => {
    if (!cardRef.current) return;

    const isVideo = /\.(mp4|webm|ogg|m4v|mov|avi|mkv|3gpp|3gp|3g2|hevc|h265)$/i.test(imgSrc);
    if (isVideo) {
      handleDownloadVideo();
      return;
    }

    const wrapper = document.createElement("div");

    try {
      setDownloading(true);
      // await preloadImage(imgSrc);
      // Clone card DOM element for better isolation (optional)
      const clone = cardRef.current.cloneNode(true);
      const rect = cardRef.current.getBoundingClientRect();
      if(isRealSafari()){
      // clone.style.margin = "0";
      // clone.style.padding = "0";
      // clone.style.boxShadow = "none";
      // clone.style.background = "#FFFFFF";
      // clone.style.borderRadius = "16px";
      // wrapper.style.padding = "0px 3px 0px 0px";
      }

      // wrapper.setAttribute("data-download-wrapper", "true");

      wrapper.style.background = "transparent";
      wrapper.style.backgroundColor = "transparent";
      wrapper.style.display = "inline-block";
      wrapper.style.boxSizing = "content-box";
      wrapper.style.boxShadow = "none";
      wrapper.style.borderRadius="16px";
      wrapper.style.width = `${rect.width}px`;
      // wrapper.style.height = `${rect.height}px`;
      // wrapper.style.width = "200px";
// wrapper.style.height = "600px";
      wrapper.appendChild(clone);
      document.body.appendChild(wrapper);

      await wait(600);
      await new Promise((r) => setTimeout(r, 800));

      // await document.fonts.ready;
      // await waitForImages(wrapper);

      const dataUrl = await toPng(wrapper, {
        cacheBust: true,
        skipFonts:true,
        backgroundColor:"transparent",
        // pixelRatio: 2,
        style: {
          transform: "none",
          margin: "0",
          boxShadow:"none!important",
          borderRadius:"16px"
        },
        filter: (node) => node.className !== "no-screenshot",
      });

      const base64Length = dataUrl.length - "data:image/png;base64,".length;
      const sizeInBytes = Math.ceil((base64Length * 3) / 4);

      console.log("sizeInBytes", sizeInBytes);
      if (sizeInBytes < 80 * 1024) {
        // Retry if under 80KB
        wrapper.remove();
        return handleDownloadImage();
      }

      const hashCode = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
          hash = (hash << 5) - hash + str.charCodeAt(i);
          hash |= 0;
        }
        return Math.abs(hash % 10000);
      };
      const shortCode = hashCode(journalId);

      const link = document.createElement("a");
      link.download = `IMG_${shortCode}.png`;
      link.href = dataUrl;
      link.click();
      notifySuccess(API_SUCCESS_MESSAGE.DOWNLOAD_REEL);
    } catch (error) {
      console.error("Download failed:", error);
      notifyError("Image download failed.");
    } finally {
      setDownloading(false);
      wrapper.remove();
      // STEP 4: Cleanup clone from DOM
      const appendedWrapper = document.body.querySelector("[data-download-wrapper='true']");
      if (appendedWrapper) appendedWrapper.remove();
    }
  };

  const handleUpdate = () => {
    JournalAPIService.journalUpdate(journalId, {
      posted_at: dayjs(editableDate).toISOString(),
      tagline: editableText,
      author,
    })
      .then((response) => {
        notifySuccess(API_SUCCESS_MESSAGE.UPDATED_SCUCESSFULLY);
        pageRefreshCallback();
      })
      .catch((errResponse) => {
        notifyError(
          errResponse?.response?.data?.message ||
            API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
        );
      });
    handleCloseDialog();
  };

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      const height = element.clientHeight;

      // If height is more than 1.5x the lineHeight, we assume it's multiline
      if (height > lineHeight * 1.2) {
        setIsSingleLine(false);
      } else {
        setIsSingleLine(true);
      }
    }
  }, [text]);

  const isVideo =
    /\.(mp4|webm|ogg|m4v|mov|avi|mkv|3gpp|3gp|3g2|hevc|h265)$/i.test(imgSrc);

    const generateVideoWithOverlay = async (overlayImage, backgroundVideo) => {

      try {
        if (!ffmpeg.loaded) await ffmpeg.load();
        console.log("overlayImage",overlayImage)
        console.log("backgroundVideo",backgroundVideo)


        const overlayArrayBuffer = await fetch(URL.createObjectURL(overlayImage)).then(res => res.arrayBuffer());
        const bgVideoArrayBuffer = await fetch(URL.createObjectURL(backgroundVideo)).then(res => res.arrayBuffer());

        await ffmpeg.writeFile("overlay.png", new Uint8Array(overlayArrayBuffer));
        await ffmpeg.writeFile("background.mp4", new Uint8Array(bgVideoArrayBuffer));

        // FFmpeg: overlay PNG onto video
        await ffmpeg.exec([
          "-i", "background.mp4",
          "-i", "overlay.png",
          "-filter_complex",
          "[0:v]scale=300:500[vid];[1:v]scale=520:720[bg];[bg][vid]overlay=(W-w)/2:(H-h)/2-50",
          "-c:v", "libx264",
          "-pix_fmt", "yuv420p",
          "-preset", "ultrafast",
          "output_overlay.mp4"
        ]);
        const data = await ffmpeg.readFile("output_overlay.mp4");
        const url = URL.createObjectURL(new Blob([data.buffer], { type: "video/mp4" }));
        // Auto-download the file
      const a = document.createElement("a");
      a.href = url;
      a.download = "Joy_Memory.mp4";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Optional: Revoke the URL after some time to free memory
      setTimeout(() => URL.revokeObjectURL(url), 1000);

        // setVideoUrl(url);
      } catch (error) {
        console.error("Error generating overlay video:", error);
      }
    };


    const handleDownloadVideo = async () => {
      if (!cardRef.current) return;

      try {
        setDownloading(true);

        const canvas = await html2canvas(cardRef.current, {
          useCORS: true,
          backgroundColor: "#ffffff",
          // scale: 3,
        });

        const dataUrl = canvas.toDataURL("image/png");
        const blob = await (await fetch(dataUrl)).blob();

        // Use your own video path here
        const backgroundVideo = await fetch(imgSrc).then(res => res.blob());; // put this in your public folder

        await generateVideoWithOverlay(blob, backgroundVideo);
      } catch (err) {
        console.error("Video generation failed:", err);
        notifyError("Video generation failed.");
      } finally {
        setDownloading(false);
      }
    };

  return (
    <>
      {/* Dialog */}
      <Dialog open={open} onClose={handleCloseDialog} fullWidth maxWidth="sm">
        <DialogContent
          sx={{
            position: "relative",
            p: 2,
            height: { xs: editMode? "550px" :"500px", sm: editMode? "550px" :"500px", md: editMode? "550px" :"500px" },
          }}
        >
          {editMode ? (
            <Button
              variant="contained"
              onClick={handleUpdate}
              sx={{
                position: "absolute",
                top: 4,
                right: 4,
                zIndex: 10000,
                marginTop: "2px",
                // marginBottom: "1px",
                // margin: "0 16px 0 0",
                fontSize: "0.5rem",
                color: "#ffff",
                background: "#005cff",
                fontFamily: "Poppins",
                textTransform: "none",
                // borderRadius: "24px",
              }}
            >
              Save and Close
            </Button>
          ) : (
            <IconButton
              onClick={handleCloseDialog}
              sx={{ position: "absolute", top: 2, right: 2, zIndex: 10000 }}
            >
              <CloseCircleOutlined />
            </IconButton>
          )}

<IconButton
                sx={{
                  position: "absolute",
                  top: 60,
                  right: 150,
                  color: "black",
                  zIndex: 1001,
                  width: { xs: "25px", sm: "30px", md: "30px" },
                  height: { xs: "25px", sm: "30px", md: "30px" },
                  "@media (max-width: 440px)": {
                    height: "20px",
                    width: "20px",
                    top:60,
                    right:40
                  },
                  "@media (min-width: 441px) and (max-width: 600px)": {
                    height: "24px",
                    width: "24px",
                    top: 80,
                    right: 50,
                  }
                  // bgcolor: "#ffffffc9",
                }}
                // onClick={handleMenuClick}
              >
                <ActionMenu action={handleMenuClick} show={isVideo} edit={editMode} drag={false} fullView={false}/>
              </IconButton>
        <div ref={cardRef} style={{width:"97%",padding: "4px",fontFamily:"Poppins, Arial, sans-serif"}}>
          <Card
            sx={{
              width: {
                xs: disableEye ? "96%" : "100%",
                sm: disableEye ? "60%" : "100%",
                md: disableEye ? "60%" : "100%",
              },
              height: {
                xs: disableEye ? (editMode ? 500 : 450) : 250,
                sm: disableEye ? editMode? 500 :450 : 340,
                md: disableEye ? editMode? 500 :450 : 340,
              },
              "@media (max-width: 370px)": {
                height: disableEye ? (editMode ? 450 : 450) : 250,
              },
              borderRadius: 4,
              marginTop: {
                xs: disableEye ? "10%" : "0%",
                sm: disableEye ? "4%" : "0%",
                md: disableEye ? "4%" : "0%",
              },
              border: `4px solid ${borderColor}`,
              position: "relative",
              overflow: "visible",
              justifySelf: "center",
              boxShadow:"none",
              bgcolor: backgroundColor || "#f9f9f9",
            }}
          >
            <Box
              sx={{
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={() => setShowEye(true)}
              onMouseLeave={() => setShowEye(false)}
            >

              {/* {!isVideo && (
                <IconButton
                  sx={{
                    position: "absolute",
                    top: 46,
                    right: 8,
                    color: "black",
                    zIndex: 1001,
                    width: { xs: "25px", sm: "30px", md: "30px" },
                    height: { xs: "25px", sm: "30px", md: "30px" },
                    bgcolor: "#ffffffc9",
                  }}
                  onClick={() => handleOpenEditor(imgSrc, journalId)}
                >
                  <img src={magicToolIcon} width="20px" height="20px" />
                </IconButton>
              )} */}

{!isVideo ?
  <Box
  className="imageRender"
  sx={{
    width: "100%",
    height: {
      xs: disableEye ? "350px" : "175px",
      sm: "350px",
      md: "350px",
    },
    borderRadius: "12px 12px 0px 0px",
    overflow: "hidden",
    position: "relative",
    boxSizing: "border-box",
    // backgroundImage: `url(${imgSrc})`,
    // backgroundSize: "cover",
    // backgroundPosition: "center",
    // backgroundRepeat: "no-repeat",
  }}
>
  <img
    src={imgSrc}
    crossOrigin="anonymous"
    alt="card-image"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      display: "block",          // 👈 removes bottom gap
      transform: "scale(1.001)", // 👈 tiny nudge to fix edge rounding issues
      transformOrigin: "center",
    }}
  />
</Box>
:
              <CardMedia
                component={isVideo ? "video" : "img"}
                image={imgSrc}
                controls
                loop
                alt="Uploaded"
                sx={{
                  objectFit: isVideo ? "none" : "contain",
                  width: "100%",
                  height: {
                    xs: disableEye ? "350px" : "175px",
                    sm: "248px",
                    md: "248px",
                  },
                  borderRadius: "12px 12px 0px 0px",
                }}
              />
}
            </Box>

            <Box
              sx={{
                bgcolor: backgroundColor,
                color: "white",
                borderRadius: "0px 0px 12px 12px",
                padding: "1px",
                textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: text?.length > 40 ? "0px" : "3px",
    paddingRight: text?.length > 40 ? "0px" : "3px",
                minHeight: {
                  xs: editMode ? "100px" : "80px",
                  sm: editMode ? "100px" : isSingleLine ? "80px" : "80px",
                  md: editMode ? "100px" : isSingleLine ? "80px" : "80px",
                },
              }}
            >
              {editMode ? (
                <TextField
                  id="outlined-basic"
                  label=""
                  variant="outlined"
                  multiline
                  rows={2}
                  value={editableText}
                  onChange={(e) => setEditableText(e.target.value)}
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-inputMultiline": {
                      textAlign: "center", // horizontal center
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    },
                  }}
                  InputProps={{
                    sx: {
                      color: textColor,
                    },
                  }}
                />
              ) : (
                <Typography
                  ref={textRef}
                  variant="body1"
                  sx={{
                    fontWeight: 500,
                    fontSize: { xs: "0.8rem", sm: "0.9rem", md: "0.9rem" },
                    color: textColor,
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                >
                  {text}
                </Typography>
              )}
            </Box>

            {editMode ? (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={dayjs(editableDate)}
                  onChange={(newValue) => setEditableDate(newValue)}
                  format={DATE.JOURNAL_FORMAT}
                  sx={{
                    position: "absolute",
                    bottom: 4,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 160,
                    "& .MuiInputBase-input": {
                      textAlign: "center",
                      padding: "5px",
                      fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.8rem" },
                      color: textColor,
                    },
                  }}
                />
              </LocalizationProvider>
            ) : (
              <Typography
                sx={{
                  position: "absolute",
                  bottom: 4,
                  left: "50%",
                  transform: "translateX(-50%)",
                  fontSize: { xs: "0.8rem", sm: "0.9rem", md: "0.9rem" },
                  color: textColor,
                }}
              >
                {dayjs(date).format(DATE.JOURNAL_FORMAT)}
              </Typography>
            )}

            {imageBottomRight && (
              <Box
                component="img"
                src={imageBottomRight}
                alt="bottom-right"
                sx={{
                  position: "absolute",
                  bottom: 5,
                  right: 5,
                  borderRadius: "50%",
                  ...imageBottomRightStyle,
                }}
              />
            )}
          </Card>
          </div>

          <ConfirmationDialog
            id="confirmation-dialog-description"
            open={confirmDialogOpen}
            title=""
            description="Are you sure you want to delete this memory?"
            onConfirm={handleConfirmDelete}
            onCancel={handleCancelDelete}
            confirmText="Delete"
            cancelText="Cancel"
            keepMounted={false}
            transition="up"
            loading={false}
          />
        </DialogContent>
      </Dialog>
      <DownloadBackdrop downloading={downloading} />
    </>
  );
};

export default ImageCardTemplateEdit;
